import React from 'react'

export default function Choncc() {
    return (
        <section className="small-section">
            <h2>Choncc (Small) Pattern</h2>
            <img width="20%" src="/images/patterns/choncc/choncc.jpg" alt="choncc"></img>
            <h3>Yarn needed:</h3>
            <p>
                <ul>
                    <li>Pink</li>
                    <li>White</li>
                    <li>Blue</li>
                    <li>Black</li>
                </ul>
                (this pattern makes the pink regular choncc, but there can be changes made in color to make other chonccs) <br />
                Please don't hesitate to reach out if you have any questions about the pattern or need help with it! <br />
                My email is dangoploof@gmail.com <br />
            </p>
            <h3>Abbreviations: </h3>
            <p>
                <ul>
                    <li>sc = single crochet</li>
                    <li>mr = magic ring</li>
                    <li>inc = increase</li>
                    <li>dec = decrease</li>
                </ul>

            </p>

            <h3>Head & Body</h3>
            <p>
                Start with pink <br></br>
                Round 1: 6 sc in a mr (6) <br></br>
                Round 2: 1 inc around (12) <br></br>
                Round 3: (1 inc, 1 sc)* repeat around (18) <br></br>
                Round 4: (2 sc, 1 inc)* repeat around (24) <br></br>
                Round 5: (3 sc, 1 inc)* repeat around (30) <br></br>
                Round 6-7: 1 sc around (30) <br></br>
                Round 8: 12 sc, <b>switch to white</b>, 6 sc, <b>switch to pink</b>, 12 sc (30)  <br></br>
                Round 9: 10 sc, <b>switch to white</b>, 1 dec, 6 sc, 1 dec, <b>switch to pink</b>, 10 sc (28) <br></br>
                Round 10: 1 dec, 7 sc, 1 dec, <b>switch to white</b>, 6 sc, <b>switch to pink</b>, 1 dec, 7 sc, 1 dec (24) <br></br>
                Round 11: (2 sc, dec)* around, <b>switch the white and pink</b> to match previous rounds (18) <br></br>
                Round 12: 2sc, (1 sc, inc)*2, <b>switch to white</b>, (1 sc, inc)*3, 1 sc, <b>switch to pink</b>, 1 inc, (1 sc, inc)*2 (26) <br></br>
                Round 13: 2sc, (1 sc, inc)*3, 1 sc <b>switch to white</b>, 1 inc, (1 sc, inc)*4, 1 sc, <b>switch to pink</b>, 1 inc, (1 sc, inc)*2, 2 sc (37) <br></br>
                Round 14: 12 sc, <b>switch to white</b>, 7 sc, inc, 7 sc, <b>switch to pink</b>, 10 sc (38) <br></br>
                Round 15-16: 12 sc, <b>switch to white</b>, 16 sc, <b>switch to pink</b>, 10 sc (38) <br></br>
                Round 17: 13 sc, <b>switch to white</b>, 16 sc, <b>switch to pink</b>, 9 sc (38) <br></br>
                Round 18: 14 sc, <b>switch to white</b>, 16 sc, <b>switch to pink</b>, 8 sc (38) <br></br>
                Round 19: 15 sc, <b>switch to white</b>, 14 sc, <b>switch to pink</b>, 9 sc (38) <br></br>
                Round 20: 15 sc, <b>switch to white</b>, 1 dec, 9 sc, 1 dec, <b>switch to pink</b>, 10 sc (36) <br></br>
                Round 21: (4 sc, 1 dec)*2, 4sc, <b>switch to white</b>, 1 dec, 4 sc, 1 dec, 2 sc, <b>switch to pink</b>, 2 sc, dec, 4 sc, 1 dec (30) <br></br>
                Round 22: (3 sc, 1 dec)*3, <b>switch to white</b>, 3 sc, 1 dec, 2 sc <b>switch to pink</b>, 1 sc, 1 dec, 3 sc, 1 dec (24) <br></br>
                Round 23: (2 sc, 1 dec)*6 in pink (18) <br></br>
                Round 24: (1 sc, 1 dec)*6 in pink (12) <br></br>
                Round 25: 1 dec around, only pink (6) <br></br>
                Cut and sew off! <br></br>
            </p>

            <h3>Tail Ball</h3>
            <p>
                Start with pink <br></br>
                Round 1: 4 sc in a mr (4) <br></br>
                Round 2: 1 inc around (8) <br></br>
                Round 3: 1 sc around (8) <br></br>
                Round 4: 1 dec around (4) <br></br>
                Cut and leave a long tail for sewing <br></br>
            </p>

            <h3>Tail</h3>
            <p>
                Start with pink <br></br>
                Round 1: 5 sc in a mr (5) <br></br>
                Round 2: 1 inc around (10) <br></br>
                Round 3-7: 1 sc around (10) <br></br>
                Cut and leave a long tail for sewing <br></br>
            </p>

            <h3>Side Horns (small) x2</h3>
            <p>
                Start with pink <br></br>
                Round 1: 4 sc in a mr (4) <br></br>
                Cut and leave a tail for sewing <br></br>
                <br></br>
            </p>
            <h3>Side Horns (large) x2</h3>
            <p>
                Start with pink <br></br>
                Round 1: 4 sc in a mr (4) <br></br>
                Round 2: 4 sc around (4) <br></br>
                Cut and leave a tail for sewing <br></br>
            </p>

            <h3>Big Horns x2</h3>
            <p>
                Start with blue <br></br>
                Round 1: 6 sc in mr (6) <br></br>
                Round 2: (1 sc, 1 inc)* repeat until end (9) <br></br>
                Round 3-5: 1 sc around (9) <br></br>
                Cut and leave a tail for sewing <br></br>
            </p>

            <h3>Arm x2</h3>
            <p>
                Start with pink <br></br>
                Round 1:  6 sc in mr (6) <br></br>
                Round 2: (1 sc, 1 inc)* around (9) <br></br>
                Round 3-8: 1 sc around (9) <br></br>
                Cut and leave a long tail for sewing <br></br>
                Use the blue to sew on 3 claws <br></br>
            </p>

            <h3>Legs x2</h3>
            <p>
                Start with white <br></br>
                Round 1: 6 sc in mr (6) <br></br>
                Switch to pink <br></br>
                Round 2: 1 inc around (12) <br></br>
                Round 3-4: 1 sc around (12) <br></br>
                Cut and leave a long tail for sewing <br></br>
                Use the blue to sew on 3 claws <br></br>
                <br></br>
                Now you can assemble choncc!! <br></br>
            </p>

            <h2>Assembly</h2>
            <p className="patternAssembly">
                <img src="/images/patterns/choncc/chonccparts.png" alt="choncc parts"></img>
                <img src="/images/patterns/choncc/chonccfinish.png" alt="choncc construction"></img>
            </p>
            <h3>Congrats on finishing!!! </h3>
            <p>
                Tag: @dango.ploof on insta to show me your chonccs!!
                </p>
            <div className="patterns">
                <a href="/patterns">Back to Patterns</a>
            </div>
        </section>
    );
}